// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"063cde85","885":"029ec7fb"}[chunkId] + ".chunk.js";
};